import type { ReactNode } from 'react'

import { cn } from '@gto/ui/cn'

export type FormContainerProps = {
  children: ReactNode
  className?: string
  'data-tst'?: string
}

export const FormContainer = ({ children, className, 'data-tst': dataTst }: FormContainerProps) => {
  return (
    <form
      className={cn('flex max-w-[560px] flex-col gap-8 sm:gap-6', className)}
      data-tst={dataTst}
    >
      {children}
    </form>
  )
}
